const setSearchAnimationColorToMatchTheme = (theme) => {
  // NOTE: This function makes use of while loops to prevent DOM-query related race conditions
  const color = theme?.palette?.primary?.main || 'black';
  const animationPane = document.querySelector('lottie-player');
  if (animationPane?.shadowRoot) {
    const MAGNIFIER_CIRCLE_PATH =
      'path[d=" M41.01599884033203,-32.500499725' +
      '3418 C47.096004486083984,-32.5004997253418 52.032501220703125,-27.5640' +
      '06805419922 52.032501220703125,-21.483999252319336 C52.032501220703125' +
      ',-15.403992652893066 47.096004486083984,-10.467498779296875 41.0159988' +
      '4033203,-10.467498779296875 C34.93599319458008,-10.467498779296875 29.' +
      '99949836730957,-15.403992652893066 29.99949836730957,-21.4839992523193' +
      '36 C29.99949836730957,-27.564006805419922 34.93599319458008,-32.500499' +
      '7253418 41.01599884033203,-32.5004997253418z"]';

    const MAGNIFIER_HANDLE_PATH =
      'path[d=" M54.49300003051758,-11.607999801' +
      '635742 C55.27199935913086,-12.378999710083008 56.527000427246094,-12.378' +
      '000259399414 57.305999755859375,-11.607000350952148 C57.305999755859375,' +
      '-11.607000350952148 64.56300354003906,-4.421999931335449 64.563003540039' +
      '06,-4.421999931335449 C65.35299682617188,-3.6389999389648438 65.35299682' +
      '617188,-2.361999988555908 64.56199645996094,-1.5789999961853027 C64.5619' +
      '9645996094,-1.5789999961853027 61.005001068115234,1.937999963760376 61.0' +
      '05001068115234,1.937999963760376 C60.22600173950195,2.7090001106262207 5' +
      '8.97100067138672,2.7090001106262207 58.19200134277344,1.937999963760376 ' +
      'C58.19200134277344,1.937999963760376 50.935001373291016,-5.2480001449584' +
      '96 50.935001373291016,-5.248000144958496 C50.14500045776367,-6.031000137' +
      '329102 50.14500045776367,-7.308000087738037 50.93600082397461,-8.0909996' +
      '03271484 C50.93600082397461,-8.090999603271484 54.49300003051758,-11.607' +
      '999801635742 54.49300003051758,-11.607999801635742z"]';

    const MAGNIFIER_SHAFT_PATH =
      'path[d=" M48.9659309387207,-13.05381965637207 ' +
      'C48.9659309387207,-13.05381965637207 61.2110595703125,-1.5869790315628052 ' +
      '61.2110595703125,-1.5869790315628052"]';

    // There is a slight difference in the path for the shaft between the standard and brand matching animations
    const MAGNIFIER_SHAFT_PATH_BRANDED =
      'path[d=" M47.90999984741211,-14.5900001525' +
      '8789 C47.90999984741211,-14.59000015258789 54.80400085449219,-7.695000' +
      '171661377 54.80400085449219,-7.695000171661377"]';

    let needsUpdate = true;
    while (needsUpdate) {
      const magnifierCircleAndLense = animationPane.shadowRoot.querySelectorAll(
        MAGNIFIER_CIRCLE_PATH
      );
      const magnifierShaftNodeList =
        animationPane.shadowRoot.querySelectorAll(MAGNIFIER_SHAFT_PATH);
      const magnifierShaftNodeList_Branded =
        animationPane.shadowRoot.querySelectorAll(MAGNIFIER_SHAFT_PATH_BRANDED);
      const magnifierHandleNodeList = animationPane.shadowRoot.querySelectorAll(
        MAGNIFIER_HANDLE_PATH
      );

      const needsCircleUpdate =
        typeof magnifierCircleAndLense === 'object' &&
        magnifierCircleAndLense.length === 2 &&
        magnifierCircleAndLense[1]?.getAttribute('stroke') !== color;
      const needsShaftUpdate =
        typeof magnifierShaftNodeList === 'object' &&
        magnifierShaftNodeList[0] &&
        magnifierShaftNodeList[0]?.getAttribute('stroke') !== color;
      const needsBrandedShaftUpdate =
        typeof magnifierShaftNodeList_Branded === 'object' &&
        magnifierShaftNodeList_Branded[0] &&
        magnifierShaftNodeList_Branded[0]?.getAttribute('stroke') !== color;
      const needsHandleUpdate =
        typeof magnifierHandleNodeList === 'object' &&
        magnifierHandleNodeList[0] &&
        (magnifierHandleNodeList[0]?.getAttribute('stroke') !== color ||
          magnifierHandleNodeList[0]?.getAttribute('fill') !== color);

      needsUpdate =
        needsCircleUpdate ||
        needsShaftUpdate ||
        needsBrandedShaftUpdate ||
        needsHandleUpdate;

      if (needsUpdate) {
        if (needsCircleUpdate) {
          magnifierCircleAndLense[1]?.setAttribute('stroke', color);
        }
        if (needsShaftUpdate) {
          magnifierShaftNodeList[0]?.setAttribute('stroke', color);
        }
        if (needsBrandedShaftUpdate) {
          magnifierShaftNodeList_Branded[0]?.setAttribute('stroke', color);
        }
        if (needsHandleUpdate) {
          magnifierHandleNodeList[0]?.setAttribute('stroke', color);
          magnifierHandleNodeList[0]?.setAttribute('fill', color);
        }
      }
    }

    // Enable visibility of the animation
    animationPane.setAttribute('style', 'opacity: 1');
  }
};

const setSuccessAnimationColorToMatchTheme = (theme) => {
  const color = theme?.palette?.primary?.main || 'black';
  const circlePath =
    'path[d=" M346.6669921875,0 C346.6669921875,191.45799255371094 191.45899963378906,346.6669921875 0,346.6669921875 C-191.45799255371094,346.6669921875 -346.6669921875,191.45799255371094 -346.6669921875,0 C-346.6669921875,-191.45899963378906 -191.45799255371094,-346.6659851074219 0,-346.6659851074219 C191.45899963378906,-346.6659851074219 346.6669921875,-191.45899963378906 346.6669921875,0z"]';
  const animationPane = document.querySelector('lottie-player');

  if (animationPane?.shadowRoot) {
    const circlePathNodeList =
      animationPane.shadowRoot.querySelectorAll(circlePath);
    while (
      typeof circlePathNodeList === 'object' &&
      circlePathNodeList[0] &&
      circlePathNodeList[0]?.getAttribute('fill') !== color
    ) {
      circlePathNodeList[0]?.setAttribute('fill', color);
      circlePathNodeList[1]?.setAttribute('fill', color);
      circlePathNodeList[2]?.setAttribute('fill', color);
    }
  }
};

const setStandardAnimationColorToMatchTheme = (theme) => {
  // NOTE: This function makes use of while loops to prevent DOM-query related race conditions
  const color = theme?.palette?.primary?.main || 'black';
  const animationPane = document.querySelector('lottie-player');

  if (animationPane?.shadowRoot) {
    const STANDARD_LOADER_PATH =
      'path[d=" M0,-184.30099487304688 ' +
      'C3.88700008392334,-184.30099487304688 7.745999813079834,-184.17999267578125 ' +
      '11.572999954223633,-183.9429931640625"]';

    const loaderPathNodeList =
      animationPane.shadowRoot.querySelectorAll(STANDARD_LOADER_PATH);
    while (
      typeof loaderPathNodeList === 'object' && // It is a NodeList, which, despite of its enumerable nature, is not an array
      loaderPathNodeList[0] &&
      loaderPathNodeList[0]?.getAttribute('stroke') !== color
    ) {
      loaderPathNodeList[0]?.setAttribute('stroke', color);
    }

    // Enable visibility of the animation
    animationPane.setAttribute('style', 'opacity: 1');
  }
};

// eslint-disable-next-line import/prefer-default-export
export {
  setSearchAnimationColorToMatchTheme,
  setSuccessAnimationColorToMatchTheme,
  setStandardAnimationColorToMatchTheme,
};
